import React from "react";
import { useNavigate } from "react-router-dom";
import { IoMdArrowBack } from "react-icons/io";
import { FiCheckCircle, FiHome, FiSearch, FiMessageCircle, FiMail } from "react-icons/fi";

const CongratContract = () => {
  const navigate = useNavigate();

  // WhatsApp support link (replace with your support number)
  const whatsappUrl = "https://wa.me/2340000000000?text=Hello%20OurASAP,%20I%20need%20help%20with%20my%20contract.";

  return (
    <div className="bg-gray-50 min-h-screen pb-12 flex flex-col justify-between">
      
      {/* 🔝 Sticky Header */}
      <div className="sticky top-0 z-30 bg-white/80 backdrop-blur-md border-b px-4 py-4 flex items-center justify-between">
        <button
          onClick={() => navigate("/")}
          className="p-2 hover:bg-gray-100 rounded-full transition text-gray-700 flex items-center gap-1"
        >
          <IoMdArrowBack size={24} />
          <span className="text-[10px] font-black uppercase tracking-widest">Home</span>
        </button>
        <h1 className="text-lg font-black text-gray-900 tracking-tight">Contract Status</h1>
        <div />
      </div>

      {/* Main Success Content */}
      <div className="max-w-xl mx-auto px-6 pt-10 w-full">
        <div className="bg-white p-8 sm:p-10 rounded-[2.5rem] shadow-xl shadow-gray-200/50 border border-gray-100 text-center space-y-6">
          
          {/* Success Icon */}
          <div className="w-20 h-20 bg-teal-100 text-teal-600 rounded-3xl flex items-center justify-center mx-auto text-3xl shadow-lg shadow-teal-50">
            <FiCheckCircle />
          </div>

          <div className="space-y-2">
            <h2 className="text-2xl font-black text-gray-900">Boom! Contract Created.</h2>
            <p className="text-sm font-bold text-teal-700">We've locked it in and sent an email to the other party.</p>
          </div>

          {/* Simple plain-English breakdown */}
          <div className="bg-gray-50 border-2 border-gray-100 rounded-2xl p-6 text-left space-y-3">
            <h4 className="text-[10px] font-black text-gray-400 uppercase tracking-widest">What happens next?</h4>
            <div className="space-y-2 text-xs font-bold text-gray-700">
                
              <p className="flex items-start gap-2">
                <span className="text-orange-600 font-black">1.</span> We emailed them the details so they can review your terms.
              </p>

              <p className="flex items-start gap-2">
                <span className="text-orange-600 font-black">2.</span> They can choose to <span className="text-teal-700 font-black">Accept</span> or <span className="text-rose-600 font-black">Reject</span> right from their inbox.
              </p>
              <p className="flex items-start gap-2">
  <span className="text-orange-600 font-black">2.</span> If rejected, we'll email you to submit your bank details for a full refund so you can start a new contract.
</p>
              <p className="flex items-start gap-2">
                <span className="text-orange-600 font-black">3.</span> We'll ping your email the exact second they make a Accepted, and we will send you the full contract details right away so you can easily keep track of everything
              </p>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="space-y-3 pt-2">
            <button
              onClick={() => navigate("/")}
              className="w-full py-4 bg-gray-900 hover:bg-black text-white rounded-[1.5rem] font-black uppercase tracking-[0.2em] text-xs transition-all shadow-xl shadow-gray-300 active:scale-95 flex items-center justify-center gap-2"
            >
              <FiHome size={16} /> Back to Homepage
            </button>
            <button
              onClick={() => navigate("/connect")}
              className="w-full py-4 bg-orange-600 hover:bg-orange-700 text-white rounded-[1.5rem] font-black uppercase tracking-[0.2em] text-xs transition-all shadow-xl shadow-orange-200 active:scale-95 flex items-center justify-center gap-2"
            >
              <FiSearch size={16} /> Find Another Seller
            </button>
          </div>
        </div>
      </div>

      {/* 📱 Bottom Contact Us / WhatsApp Section */}
      <div className="max-w-xl mx-auto px-6 w-full mt-12 text-center">
        <div className="border-t border-gray-200 pt-6 space-y-2">
          <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest">Need fast help?</p>
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-teal-50 hover:bg-teal-100 text-teal-800 rounded-2xl font-black text-xs uppercase tracking-wider transition shadow-sm"
          >
            <FiMessageCircle size={16} className="text-teal-600" /> Contact Us on WhatsApp
          </a>
        </div>
        <p className="text-[10px] font-black text-gray-300 uppercase tracking-widest mt-6">
          Fast Deals • Zero Stress • OurASAP
        </p>
      </div>

    </div>
  );
};

export default CongratContract;